import PagesTabs, { PageProps } from "./tabs";
import { StaticImageData } from "next/image";
import {
  PUBLIC_CLOUD_CONSTANTS,
  COMPUTE_CONSTANTS,
} from "@/components/header/header.constants";

const PublicCloudTabs = () => {
  const NEW_PUBLIC_CLOUD_CONSTANTS: PageProps[] = [
    ...COMPUTE_CONSTANTS,
    ...PUBLIC_CLOUD_CONSTANTS.filter(
      (item): item is { image: StaticImageData; label: string; href: string } =>
        item.label !== "Compute"
    ),
  ];
  return <PagesTabs props={NEW_PUBLIC_CLOUD_CONSTANTS} />;
};

export default PublicCloudTabs;
